import OutputSelectionManager from "../manager/OutputSelectionManager";
import {satGlobals} from "../../../../../sat/helper/sat-globals";
import axios from 'axios';
import {useResultPageStore} from "../stores/ResultPageStore";
import Analytics from "./Analytics";

class Reconvert {

    listener = false;

    constructor() {
    }

    async redoSelected(job) {
        await Analytics.sendWithData('result_reconvert', 'reconvert_start_over', job, {target: 'self'});

        window.location.href = job.apiJob.sat_links.redo.href.link + '#j=' + job.apiJob.id;
    }

    async reconvertSelected(job) {
        await Analytics.sendWithData('result_reconvert', 'reconvert_selected', job, {target: 'self'});

        let storageId = await this.createReconvertStorage(job);

        window.location.href = job.apiJob.sat_links.redo.href.link + '#su=' + storageId;
    }

    async continueWithSelected(job, operation) {
        await Analytics.sendWithData('result_reconvert', 'reconvert_continue_with_selected', job, {target: operation});

        let storageId = await this.createReconvertStorage(job);

        let targetOperation = job.apiJob.sat_links.reconvert.find(reconvertItem => reconvertItem.operation === operation)

        window.location.href = targetOperation.href.link + '#su=' + storageId;
    }

    async continueWithSelectedTool(job, operation) {
        await Analytics.sendWithData('result_reconvert', 'reconvert_continue_with_selected_tool', job, {target: operation});

        this.store = useResultPageStore();
        let storageId = await this.createReconvertStorage(job);

        let targetOperation = this.store.resultPage.tools.links.find(reconvertItem => reconvertItem.operation === operation)

        window.location.href = targetOperation.link + '#su=' + storageId;
    }

    async continueWithSelectedExport(job, operation) {
        await Analytics.sendWithData('result_reconvert', 'reconvert_continue_with_selected_export', job, {target: operation});

        let storageId = await this.createReconvertStorage(job);

        let targetOperation = job.apiJob.sat_links.export_as.find(reconvertItem => reconvertItem.feature.operation === operation)

        window.location.href = targetOperation.feature.href.link + '#su=' + storageId;
    }

    async createReconvertStorage(job) {
        let urls = this.getReconvertUrls(job);
        let response;

        try {
            response = await axios.post(satGlobals.getApiUrl('api/storage/url'), urls, {withCredentials: true});
        } catch (err) {
            if (err.response) {
            }

            return null;
        }

        return response.data.id;
    }

    getReconvertUrls(job) {
        return OutputSelectionManager.getSelectedUrls(job)
    }

    getReconvertList(job) {
        return job.apiJob.sat_links.reconvert;
    }

    getExportAsList(job) {
        return job.apiJob.sat_links.export_as;
    }
}

export default new Reconvert()